import InlineTextInput from '@/components/ui/inline-text-input';
import { pdkAxios } from '@/lib/pdk-axios';
import type { Trade } from '@/models/types';
import { tradesStore } from '@/stores/trades-store';
import { useMutation } from '@tanstack/react-query';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

const TradeVehicleNumberOfKeysEditor = ({
  tradeId,
  initialNumberOfKeys,
}: {
  tradeId: Trade['id'];
  initialNumberOfKeys: number;
}) => {
  const [numberOfKeys, setNumberOfKeys] = useState(
    initialNumberOfKeys?.toString() || '',
  );

  const updateNumberOfKeysMutation = useMutation({
    onMutate: async ({ numberOfKeys }: { numberOfKeys: number }) => {
      tradesStore.updateTrade(tradeId, {
        number_of_keys: numberOfKeys,
      });
    },
    mutationFn: async ({ numberOfKeys }: { numberOfKeys: number }) => {
      const response = await pdkAxios.post(
        `/trades/${tradeId}/number_of_keys`,
        // /api/trades/:trade_id/number_of_keys
        {
          number_of_keys: numberOfKeys,
        },
      );

      return response.data;
    },
    onSuccess: () => {},
    onError: (error, variables) => {
      console.error('Error updating number of keys', error, variables);
      // TODO: handle error by adding the original cdkId back to the store
    },
  });

  const handleNumberOfKeysChange = useCallback(
    debounce((newNumberOfKeys: number) => {
      // toast({
      //   title: 'Number of Keys change not implemented',
      //   description: `Mileage change is not implemented yet. ${newMileage}`,
      // });
      updateNumberOfKeysMutation.mutate({
        numberOfKeys: newNumberOfKeys,
      });
    }, 1000),
    [],
  );

  useEffect(() => {
    if (numberOfKeys === (initialNumberOfKeys?.toString() || '')) return;

    const parsedNumberOfKeys = parseInt(numberOfKeys);

    if (isNaN(parsedNumberOfKeys)) return;

    handleNumberOfKeysChange(parsedNumberOfKeys);
  }, [numberOfKeys]);

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setNumberOfKeys(e.target.value);
  }, []);

  useEffect(() => {
    setNumberOfKeys(initialNumberOfKeys?.toString() || '');
  }, [initialNumberOfKeys]);

  return (
    <div className="flex flex-row gap-1 items-center justify-between">
      <div className="flex flex-row gap-1 items-center">
        <div className="text-sm text-gray-500 dark:text-white">
          Number of Keys
        </div>
      </div>
      <InlineTextInput
        value={numberOfKeys?.toString()}
        onChange={onChange}
        placeholder="Enter number of keys"
        className="text-right"
        wrapperClassName="gap-1"
      />
    </div>
  );
};

export default TradeVehicleNumberOfKeysEditor;
